<template>
  <v-main :class="{ 'auth-background': !$vuetify.breakpoint.xs }">
    <v-container class="pa-0" :class="{ 'elevation-1': !$vuetify.breakpoint.xs }" style="max-width:1000px;">
      <v-row >
        <v-col
          style="background: #ffb300"
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="5"
          class="logo"
        >
          <div class="pt-10">
            <logo-sologan></logo-sologan>
          </div>
        </v-col>

        <v-col style="background: #fff" cols="12" sm="12" md="7" lg="7" xl="7">
          <div class="mx-sm-4 px-sm-4 mx-md-10 px-md-10 py-sm-15 py-md-15 py-lg-15 xs-screen">
            <v-form ref="form">
              <div class="d-flex justify-center">
                <div
                  class="text-h4 py-5 font-weight-bold"
                  style="color: #ffb300"
                >
                  Đăng ký
                </div>
              </div>
              <v-text-field
                placeholder="Tên đăng nhập"
                prepend-inner-icon="person"
                v-model="credentials.identifier"
                :rules="[$rules.required, $rules.minLength(4)]"
                validate-on-blur
                @keyup.enter="submit"
                type="text"
              />

              <v-text-field
                placeholder="Nhập email của bạn"
                prepend-inner-icon="email"
                v-model="email"
                :rules="[$rules.required, $rules.email]"
                validate-on-blur
                @keyup.enter="submit"
                type="text"
              />

              <v-text-field
                placeholder="Mật khẩu"
                v-model="password"
                :append-icon="newPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="newPassword ? 'text' : 'password'"
                :rules="[$rules.required, $rules.minLength(4)]"
                @keyup.enter="submit"
                @click:append="newPassword = !newPassword"
                prepend-inner-icon="lock"
                validate-on-blur
              />

              <v-text-field
                placeholder="Nhập lại mật khẩu"
                v-model="passwordConfirmation"
                :append-icon="checkPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="checkPassword ? 'text' : 'password'"
                :rules="[$rules.required, $rules.minLength(4)]"
                validate-on-blur
                prepend-inner-icon="lock"
                @keyup.enter="submit"
                @click:append="checkPassword = !checkPassword"
              />
            </v-form>

            <v-card-actions
              class="d-flex flex-column justify-content-center pt-6"
            >
              <v-btn
                href="/confirm-email"
                color="#FFB300"
                class="px-12 white--text"
                x-large
                @click="submit"
                >Đăng Ký</v-btn
              >
            </v-card-actions>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import { mapActions } from 'vuex'
import LogoSologan from '@/modules/image_logo/logo_sologan.vue'
export default {
  components: { LogoSologan },
  data() {
    return {
      credentials: {
        identifier: '',
        password: '',
      },
      loading: false,
      newPassword: false,
      checkPassword: false,
      password: '',
      rules: {
        min: (v) => v.length >= 6 || 'Min 6 characters',
      },
    }
  },
  methods: {
    ...mapActions('auth', ['signIn']),
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        await this.signIn(this.credentials)
        this.loading = false
      }
    },
  },
}
</script>
<style scoped>
.auth-background {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url('../../assets/background.svg') no-repeat center center;
  background-size: cover;
  transform: scale(1);
}
.round{
  border-radius: 10px;
}
.logo {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
@media screen and (max-width: 600px) {
  .xs-screen {
    padding: 20px;
  }
}
</style>
